import React, { useEffect, useRef, useState, FunctionComponent } from 'react';

import { createBoard } from '@api/v4/boards';
import { BoardResponse, BoardResponseObject } from '@api/v4/boards/boardsTypes';
import renderModal from '@components/show_page/modals/renderModal';
import { CloseButton, PrimaryButton, } from '@components/library/button/index';

interface CreateBoardHandlerParams {
  boardTitle: string;
  closeModal: () => void;
  setBoards: React.Dispatch<React.SetStateAction<BoardResponseObject[]>>;
}
// reflect success or error message
// TODO add notify
const createBoardHandler = async (options: CreateBoardHandlerParams): Promise<void> => {
  const { boardTitle, closeModal, setBoards } = options;
  try {
    // reponse is created board
    const newBoard: BoardResponse = await createBoard({ boardTitle });
    setBoards((prevState) => prevState.concat([newBoard.data]));
    Notify.create({ title: t("Board successfully created."), type: "success" });
  } catch (error) {
    Notify.create({ title: t("Something went wrong, creating board failed."), type: "error" });
  } finally {
    closeModal();
  }
};

interface CreateBoardModalProps {
  closeModal: () => void;
  setBoards: React.Dispatch<React.SetStateAction<BoardResponseObject[]>>;
}
// setBoards is the setState handler of the parent/calling component
const CreateBoardModal: FunctionComponent<CreateBoardModalProps> = (options) => {
  const { closeModal, setBoards } = options;
  const [newBoardTitle, setNewBoardTitle] = useState("");
  const input = useRef(null);

  useEffect(() => {
    input.current.focus();
    return closeModal; // fire closeModal when unmounting
  }, []);

  return (
    <div className="modal-content-wrapper create-board-modal">
      <div className="modal-content-wrapper__header">
        <span className="bff-boards icon" aria-hidden="true" />
        <h3 className="modal-title">{t("Create New Board")}</h3>
        <CloseButton onClick={closeModal} />
      </div>
      <div className="modal-content-wrapper__body">
        <div className="create-board-input-container">
          <label className="brandfolder-label">
            {t("Board Name")}
            <input
              ref={input}
              className="brandfolder-input"
              name="board-name"
              onChange={(e): void => setNewBoardTitle(e.target.value)}
            />
          </label>
        </div>
        <div className="button-container">
          <PrimaryButton
            className="t-confirm-modal"
            disabled={newBoardTitle.length === 0}
            onClick={(): Promise<void> => createBoardHandler({ boardTitle: newBoardTitle.trim(), closeModal, setBoards })}
            size="medium"
          >
            {t("Create Board")}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

const ModalComponent = renderModal(CreateBoardModal, 'CreateBoardModal');
export default ModalComponent;
